module.exports = __webpack_public_path__ + "img/heykama.80557bd3.svg";